import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import GlassSpinner from "../components/GlassSpinner";
import { waitlistStatus } from "../services/sininApi";
import axios from "axios";

const API = "https://mocaub1h8d.execute-api.us-east-1.amazonaws.com/prod";

export default function WaitlistEstado() {
  const { empresaId, eventoId, dni } = useParams();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id") || "";

  const [cfg, setCfg]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [status, setStatus]   = useState(null); // { waitlist_estado, ticket, ws_phone }

  const GOLD   = cfg?.colorTicket || "#25f4df";
  const FONDO  = cfg?.colorFondo  || "#1a1a1a";
  const FUENTE = cfg?.colorFuente || "#ffffff";

  useEffect(() => {
    const load = async () => {
      try {
        const r = await axios.post(`${API}/sinin_gestionarEmpresas`, {
          action: "get", empresaId: empresaId.toLowerCase(),
        });
        setCfg(r.data?.empresa || {});
      } catch { setCfg({}); }

      try {
        const r = await waitlistStatus(empresaId.toLowerCase(), eventoId, id, dni);
        setStatus(r);
      } catch { setStatus(null); }

      setLoading(false);
    };
    load();
  }, [empresaId, eventoId, id, dni]);

  if (loading) return (
    <div style={{ minHeight: "100vh", background: FONDO, display: "flex",
      alignItems: "center", justifyContent: "center" }}>
      <GlassSpinner size={60} background={FONDO} />
    </div>
  );

  const ticket    = status?.ticket;
  const wsPhone   = status?.ws_phone || "";
  const wsLink    = wsPhone
    ? `https://wa.me/${wsPhone}?text=${encodeURIComponent("Hola! Quiero consultar el estado de mi entrada.")}`
    : null;

  const empresa_nombre = cfg?.nombre || empresaId.toUpperCase();

  const btnStyle = {
    background: GOLD, color: cfg?.colorFuente || "#042b28", border: "none",
    borderRadius: 25, padding: "14px 24px", cursor: "pointer", fontWeight: "900",
    fontSize: 14, textTransform: "uppercase", width: "100%", display: "block",
    textDecoration: "none", textAlign: "center", marginBottom: 10,
  };

  const cardStyle = {
    maxWidth: 420, width: "100%", textAlign: "center",
  };

  const wrap = (icon, title, body, action) => (
    <div style={{ minHeight: "100vh", background: FONDO, display: "flex",
      alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={cardStyle}>
        {cfg?.logoUrl && (
          <img src={cfg.logoUrl} alt="logo"
            style={{ maxHeight: 70, maxWidth: 180, objectFit: "contain", marginBottom: 20 }} />
        )}
        <div style={{ fontSize: 48, marginBottom: 12 }}>{icon}</div>
        <div style={{ color: FUENTE, fontSize: 20, fontWeight: "800", marginBottom: 8 }}>{title}</div>
        <div style={{ color: "rgba(255,255,255,.65)", fontSize: 14, lineHeight: 1.6, marginBottom: 28 }}>{body}</div>
        {action}
      </div>
    </div>
  );

  // Tiene ticket generado → mostrar link de descarga
  if (ticket?.pdf_url) {
    return wrap(
      "🎟️",
      "¡Tu entrada está lista!",
      `Hola ${ticket.first_name}, tu entrada para ${empresa_nombre} ya fue generada. Podés descargarla o verla desde acá.`,
      <a href={ticket.pdf_url} target="_blank" rel="noreferrer" style={btnStyle}>
        Ver / descargar entrada
      </a>
    );
  }

  // Está en la lista de espera pendiente
  if (status?.waitlist_estado === "pendiente") {
    return wrap(
      "⏳",
      "En lista de espera",
      `Estás anotado pero aún no tenemos confirmación para vos. Te avisamos cuando tu entrada esté lista.`,
      wsLink && (
        <a href={wsLink} target="_blank" rel="noreferrer" style={btnStyle}>
          Consultar por WhatsApp
        </a>
      )
    );
  }

  // Fue rechazado
  if (status?.waitlist_estado === "rechazado") {
    return wrap(
      "❌",
      "No pudiste entrar esta vez",
      `Lo sentimos, tu solicitud no fue confirmada para este evento.`,
      wsLink && (
        <a href={wsLink} target="_blank" rel="noreferrer" style={{ ...btnStyle, background: "rgba(255,255,255,.15)", color: FUENTE }}>
          Consultar por WhatsApp
        </a>
      )
    );
  }

  // No encontramos nada
  return wrap(
    "🔍",
    "No encontramos tu solicitud",
    "No hay registro de tu solicitud para este evento. Si creés que es un error, contactanos por WhatsApp.",
    wsLink && (
      <a href={wsLink} target="_blank" rel="noreferrer" style={btnStyle}>
        Consultar por WhatsApp
      </a>
    )
  );
}
